// extracted by mini-css-extract-plugin
export var discard = "_44-3";
export var muiTooltipTooltip = "_44-5";
export var notificationBar = "_44-2";
export var saveButtonHoverSlotWrapper = "_44-4";
export var show = "_44-1";
export var spacer = "_44-0";